export default "__VITE_ASSET__baddf98b__"